import FieldUnit from "views/logic/aggregationbuilder/FieldUnit";
import FieldType from "./FieldType";
class FieldTypeMapping {
  constructor(name, type, unit) {
    this.value = { name, type, unit };
  }
  get name() {
    return this.value.name;
  }
  get type() {
    return this.value.type;
  }
  get unit() {
    return this.value.unit;
  }
  static fromJSON(value) {
    const { name, type, unit } = value;
    return new FieldTypeMapping(name, FieldType.fromJSON(type), FieldUnit.fromJSON(unit));
  }
  static create(name, type, unit) {
    return new FieldTypeMapping(name, type, unit);
  }
}
export default FieldTypeMapping;
